import { useProtectionPlanInfo } from '@root/components/checkout/hooks/use_protection_plan_info';
import { useProtectionTaxRate } from '@root/components/checkout/hooks/use_protection_tax_rate';
import { useStoragePlanInfo } from '@root/components/checkout/hooks/use_storage_plan_info';
import { useStorageTaxRate } from '@root/components/checkout/hooks/use_storage_tax_rate';

import { ProtectionPlanNaming } from '@utils/protection_plan';

import {
  DEFAULT_RESERVATION_SUMMARY_PROPS,
  type ReservationSummaryProps,
} from './reservation_summary_props';

export const useReservationSummaryProps = (
  naming: ProtectionPlanNaming = 'classic',
): ReservationSummaryProps => {
  const storageTaxRate = useStorageTaxRate();
  const protectionTaxRate = useProtectionTaxRate();
  const storagePlanDetail = useStoragePlanInfo();
  const protectionPlanDetail = useProtectionPlanInfo(naming);

  if (!storagePlanDetail) return DEFAULT_RESERVATION_SUMMARY_PROPS;

  const storagePlanAmount = storagePlanDetail.amount;
  const protectionPlanAmount = protectionPlanDetail.amount;

  const storagePlanTax = storagePlanAmount * (storageTaxRate / 100.0);
  const protectionPlanTax = protectionPlanAmount * (protectionTaxRate / 100.0);

  const monthlyTotalAmount = storagePlanAmount + protectionPlanAmount;

  return {
    summaryLoaded: true,
    storagePlanLabel: storagePlanDetail.label,
    protectionPlanAmount,
    protectionPlanLabel: protectionPlanDetail.label,
    storagePlanAmount,
    monthlyTotalAmount,
    storagePlanTax,
    protectionPlanTax,
  };
};
